/** PURE_IMPORTS_START .._.._Observable,.._.._operator_windowCount PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { windowCount } from '../../operator/windowCount';
Observable.prototype.windowCount = windowCount;
//# sourceMappingURL=windowCount.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/windowCount.js
// module id = ./node_modules/rxjs/_esm5/add/operator/windowCount.js
// module chunks = vendor